export default {
  overviewTitle: 'BMI Data Rapporten',
  detailTitle: 'Rapport',
  deleteTitle: 'dit Rapport',
  url: '/site/reports',
  apiUrl: '/bd_sitereports/',
  sortBy: ['date'],
  sortDesc: [true],
  deletable: false,
  editable: false,
  addRecord: false,
  multiSelect: true,
  filterName: 'site/reports',
  quickFilter: {
    text: 'Zoek op rapport, serienr, installatienr',
    value: 'misc_search',
    type: 'text'
  },
  advancedSearchFields: [
    // {text: 'Gepland van', value: 'planned_date_ge', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    // {text: 'Gepland tot', value: 'planned_date_le', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Enkel niet-gelinkt', value: 'unlinked_only', type: 'boolean', columns: 3, labelCols: 3, inputCols: 9}
    // {text: 'Keurder', value: 'inspector_id', type: 'optionList', optionListName: 'users', optionListParams: {is_inspector: true}, columns: 3, labelCols: 3, inputCols: 9}
  ],
  newRecord: {
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Datum', value: 'date', width: '20%'},
    {text: 'Rapport Code', value: 'report_code', width: '20%'},
    {text: 'Site Naam', value: 'site_name', width: '30%'},
    // {text: 'Certificate_Code', value: 'certificate_code', width: '10%'},
    {text: 'Opmerkingen', value: 'remarks', width: '20%'},
    // {text: 'Due_Date', value: 'due_date', width: '10%'},
    {text: 'Palen', value: 'pole_count', width: '10%'}
  ]
};
